module.exports = __webpack_public_path__ + "e89d3194852ee4f310b6471086087b84.svg";